import { useTranslation } from 'react-i18next'

import { getHeaderTitle } from 'pages/tours/search-result-page/libs/getHeaderTitle'

import { getTouristCount } from 'entities/tour/libs/getTouristCount.ts'
import searchTourStore from 'entities/tour/models/search-tour/search-tour'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { addDate, dateFormat } from 'shared/lib/dateFormat'

export const useHeaderMeta = () => {
  const { t } = useTranslation()
  const data = searchTourStore.getDataForSearchTour()

  const endDate = addDate({
    date: data?.flight?.startDay,
    count: data?.duration || 0,
    type: 'day',
  })

  const countTourist = getTouristCount(data)

  const title = getHeaderTitle(data, t)
  let subtitle = `${dateFormat(
    data?.flight?.startDay!,
    DATE_FORMAT_LIST.DATE_MONTH_SHORT,
  )}`

  if (data?.is_flexible_date) {
    subtitle += ` ${t('tours_block.dynamic_days', { nights: '3' })} •`
  } else {
    subtitle += ` - ${dateFormat(endDate, DATE_FORMAT_LIST.DATE_MONTH_SHORT)} •`
  }

  if (data?.is_flexible_nights) {
    subtitle += ` ${data?.duration || 0}${t('tours_block.dynamic_nights', { nights: '3' })} •`
  } else {
    subtitle += ` ${t('tours_block.nights_short', { night: data?.duration || 0 })} •`
  }

  subtitle += ` ${t('tours_block.tours_count', { count: countTourist })}`

  return { title, subtitle }
}
